import { render, staticRenderFns } from "./ProductsViewHeroBase.vue?vue&type=template&id=6a65773c&scoped=true"
import script from "./ProductsViewHeroBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsViewHeroBase.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductsViewHeroBase.vue?vue&type=style&index=0&id=6a65773c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a65773c",
  null
  
)

export default component.exports